import { createSelector } from 'reselect';
const userStateSelector = (state) => state.user;
const userAppsStateSelector = createSelector(userStateSelector, (user) => user.apps);
const loadUserAppsSelector = createSelector(userAppsStateSelector, (userApps) => userApps.loadUserApps);
const loadUserAppsDataSelector = createSelector(loadUserAppsSelector, (loadUserApps) => loadUserApps.data);
const loadUserAppsIsLoadingSelector = createSelector(loadUserAppsSelector, (loadUserApps) => loadUserApps.isLoading);
const loadUserAppsErrorSelector = createSelector(loadUserAppsSelector, (loadUserApps) => loadUserApps.error);
const pullUserAppsSelector = createSelector(userAppsStateSelector, (userApps) => userApps.pullUserApps);
const pullUserAppsSuccessSelector = createSelector(pullUserAppsSelector, (pullUserApps) => pullUserApps.success);
const pullUserAppsIsLoadingSelector = createSelector(pullUserAppsSelector, (pullUserApps) => pullUserApps.isLoading);
const pullUserAppsErrorSelector = createSelector(pullUserAppsSelector, (pullUserApps) => pullUserApps.error);
const deleteUserAppSelector = createSelector(userAppsStateSelector, (userApps) => userApps.deleteUserApp);
const deletedUserAppNameSelector = createSelector(deleteUserAppSelector, (deleteUserApp) => deleteUserApp.deletedAppName);
const deleteUserAppIsLoadingSelector = createSelector(deleteUserAppSelector, (deleteUserApp) => deleteUserApp.isLoading);
const deleteUserAppErrorSelector = createSelector(deleteUserAppSelector, (deleteUserApp) => deleteUserApp.error);
export default {
    loadUserAppsDataSelector,
    loadUserAppsIsLoadingSelector,
    loadUserAppsErrorSelector,
    pullUserAppsSuccessSelector,
    pullUserAppsIsLoadingSelector,
    pullUserAppsErrorSelector,
    deletedUserAppNameSelector,
    deleteUserAppIsLoadingSelector,
    deleteUserAppErrorSelector,
};
